<div *ngIf="!assmntReadOnly" class="dashboard-tile" style="height:100%">
  <div class="tile-header">
    <div class="tile-header-title">{{survey?.currentPage.title}}</div>
    <div class="tile-header-action">
      <div *ngIf="showAssmntFeatures" class="custom-progress-bar" style="width:400px;margin:10px;">
        <div class="bg-primary" [ngStyle]="{'width': getProgressPercent()}">{{getProgressPercent()}}</div>
      </div>
    </div>
  </div>

  <div class="tile-content">
    <div id='surveyElement' style="padding-bottom:20px; overflow: auto"></div>
    <div *ngIf="showSurveyNavigation" class="tile-footer centered">
      <button mat-raised-button color="primary" *ngIf="showSurveyNavigation" [disabled]="survey?.isFirstPage" (click)="prevPage()">&lt; Prev</button>
      <button mat-raised-button color="primary" *ngIf="showSurveyNavigation && !survey?.isLastPage" (click)="nextPage()">Next &gt;</button>
      <button mat-raised-button color="primary" *ngIf="showSurveyNavigation && survey?.isLastPage && showAssmntFeatures" (click)="survey.completeLastPage()">Complete</button>
    </div>
  </div>
</div>
<ng-container *ngIf="accountAssessment?.assessmentType == 'CERTIFICATION' && assmntReadOnly" >
  <div class="tile-content">
    <ng-container *ngFor="let dataSet of questionDataSet">
      <div fxLayout="column" fxLayoutAlign="start stretch" >
        <span class="question-title bg-primary">{{dataSet.title}}</span>
      </div>
      <ng-container *ngFor="let x of dataSet.questions">
        <div fxLayout="column" fxLayoutAlign="start stretch">
          <span class="question-title bg-primary-shade">Q: {{x.question}}</span>
          <div fxLayout="column">
            <ng-container *ngIf="x.type=='text'">
              <span class="question-answer">A: {{x.answer}}</span>
            </ng-container>
            <ng-container *ngIf="x.type=='radiogroup'">
              <span class="question-answer">A: {{x.answer.text}}</span>
            </ng-container>
            <ng-container *ngIf="x.type=='checkbox'">
              <ng-container *ngFor="let xR of x.answer; index as i">
               <span class="question-answer-checkbox">A.{{i+1}}: {{xR}}</span>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <div class="tile-footer centered" *ngIf="showButton">
      <button  *ngIf="accountAssessment?.isAssessmentAllowed === 'true'" mat-raised-button color="primary" (click)="buttonAction()">Return to Partner</button>
      <div *ngIf="accountAssessment?.isAssessmentAllowed === 'false'" matTooltip="Account is currently inactive">
        <button [disabled]="accountAssessment?.isAssessmentAllowed === 'false'" mat-raised-button color="primary">Return to Partner</button>
      </div>
    </div>    
  </div>
</ng-container>